import { Type } from '@angular/core';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterForInstanceOf<T>(instanceType: Type<T>) {
  return pipe(filter((x): x is T => x instanceof instanceType));
}
